import { BaseModelDto } from '../../base'
import { Field, Int, ObjectType } from '@nestjs/graphql'
import { ArcDto } from '../../arc'
import { ReviewerThreadUserDto } from './reviewerThreadUser.dto'
import { AuthorThreadUserDto } from './authorThreadUser.dto'

@ObjectType()
export class MessageThreadDto extends BaseModelDto {
  // New, Read
  @Field(t => Int)
  state!: number

  @Field()
  stateDate!: Date

  @Field(t => Int)
  arcId!: number

  @Field(t => Int)
  reviewerUserId!: number

  @Field(t => ArcDto)
  arc!: ArcDto

  @Field(t => AuthorThreadUserDto)
  authorUser!: AuthorThreadUserDto

  @Field(t => ReviewerThreadUserDto)
  reviewerUser!: ReviewerThreadUserDto

  @Field(t => Int)
  messageCount!: number

  @Field(t => Int)
  unreadMessageCount!: number

  @Field()
  lastMessageDate!: Date

  @Field()
  lastMessageText!: string

  // This will be scoped to the current user so we know not to show the messages as this user
  // has blocked the recipient.
  @Field()
  blocked!: boolean
}
